import clsx from "clsx";
import firebase from "firebase/app";
import Link from "next/link";
import React from "react";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { useUserBasicInfoQuery } from "@/generated/generated-hooks";
import {
  getAbsoluteUserProfilePath,
  getEtherscanUrl,
} from "@/helpers/common/path";

export const NFTDisplayName = ({
  walletAccount,
  className,
  analyticsEvent,
}: {
  walletAccount: string;
  className?: string;
  analyticsEvent?: AnalyticsEventEnum;
}) => {
  const { data: matchedUser } = useUserBasicInfoQuery({
    variables: {
      walletAccount,
    },
    context: { batch: true },
  });

  const href = matchedUser?.user
    ? getAbsoluteUserProfilePath(matchedUser?.user.accountName)
    : getEtherscanUrl(walletAccount);

  const onClick = () => {
    firebase
      .analytics()
      .logEvent(analyticsEvent ?? AnalyticsEventEnum.NftDisplayNameClick, {
        walletAccount,
      });
  };

  return (
    <Link href={href}>
      <a
        target="_blank"
        rel="noopener noreferrer"
        className="flex min-w-0"
        onClick={onClick}
      >
        <span className={clsx("inline-block align-bottom truncate", className)}>
          {matchedUser?.user ? matchedUser.user.displayName : walletAccount}
        </span>
      </a>
    </Link>
  );
};
